import type { GetMyCampaignStatusesResponse } from "schema/gen/es/chiikipoint/wallet/v2/service_pb";
import { R7_SHIGA_OTSU_CAMPAIGN_START_DATE } from "../../../config";
import type { TenantWithFeature } from "../../../libs/connect";

export type R7ShigaOtsuCampaignBannerType =
  | "not-applied" // 未応募バナー
  | "applied" // 応募済みバナー
  | "campaign-ended" // キャンペーン終了バナー
  | "hidden"; // バナー非表示

export function getR7ShigaOtsuCampaignBannerType(
  campaignStatuses: GetMyCampaignStatusesResponse | null,
  currentDate: Date,
  tenant: TenantWithFeature,
): R7ShigaOtsuCampaignBannerType {
  // 大津市テナント以外の場合は非表示
  if (tenant.slug !== "shiga-otsu") {
    return "hidden";
  }

  // キャンペーン開始前は非表示
  if (currentDate < R7_SHIGA_OTSU_CAMPAIGN_START_DATE) {
    return "hidden";
  }

  // APIレスポンスがない場合は非表示
  if (!campaignStatuses) {
    return "hidden";
  }

  const { r7OnSignup } = campaignStatuses;

  // 応募済みの場合は応募済みバナー
  if (r7OnSignup?.isApplied) {
    return "applied";
  }

  // 当選上限に達した場合はキャンペーン終了バナー
  if (r7OnSignup?.isWinLimitReached) {
    return "campaign-ended";
  }

  // それ以外は未応募バナー
  return "not-applied";
}
